import * as THREE from 'three'

export default class Grid {
    /**
     * Constructor
     */
    constructor(_options) {
        this.time = _options.time
        this.sizes = _options.sizes
        this.cursor = _options.cursor
        this.renderer = _options.renderer

        this.canvas = document.createElement('canvas')
        this.canvas.width = 1
        this.canvas.height = 1

        this.context = this.canvas.getContext('2d')
        this.context.fillStyle = '#f7f8fa'
        this.context.fillRect(0, 0, 1, 1)

        this.texture = new THREE.Texture(this.canvas)
        this.texture.needsUpdate = true
        this.name = 'white'
        this.hasLevels = false
    }

    /**
     * Resize
     */
    resize() {
    }

    /**
     * Update
     */
    update() {
    }

    /**
     * Dispose
     */
    dispose() {
        this.texture.dispose()
    }
}



// WEBPACK FOOTER //
// ./src/scripts/libs/experience/White.js